import { getAssetPath } from '@/constants/configs';
import {
  defaultConfigs,
  getExtraBasicInfoQuestions as defaultGetExtraBasicInfoQuestions,
  resolveICBWebUrl,
} from '@/constants/tenant-configs/default';

import { QuestionCode } from '@/types/api/pep';
import { AppConfigurations } from '@/types/app-configurations';
import { DocumentType } from '@/types/document';
import { Profession, User } from '@/types/user';

import { isBusinessPurposeQuestionEnabled, isMinorUser } from '@/utils/user';

export const saintKittsNevisConfigs: AppConfigurations = {
  ...defaultConfigs,
  links: {
    ...defaultConfigs.links,
    privacyPolicyURL:
      'https://www.republicbankstkitts.com/about/privacy-policy',
    termsAndConditionsURL:
      'https://republiconline.republictt.com/kn/legal.html',
    termsOfUseURL: getAssetPath('/tnc/republiconboard-tnc-kna.pdf'),
    appTermsAndConditionsURL: getAssetPath('/tnc/republiconboard-tnc-kna.pdf'),
    biometricConsentURL: getAssetPath(
      '/bio-consent/republiconboard-biometric-consent-kna.pdf',
    ),
    icbWeb: resolveICBWebUrl(
      'https://republiconlineec.rfhl.com/RBEC.UI/#/administrationGeneral/login',
    ),
    icbIOS: 'https://apps.apple.com/us/app/republicmobile-ec/id1582093121',
    icbAndroid:
      'https://play.google.com/store/apps/details?id=ecicprod.com.republicapp',
    eFreeURL: 'https://www.republicbankstkitts.com/personal/e-free-account',
    savingsPlusURL:
      'https://www.republicbankstkitts.com/personal/savings-plus-account',
  },
  defaultCountryCode: '1869',
  locale: 'en-KN',
  isoCode: 'KNA',
  dateFormat: 'dd/MM/yyyy',
  defaultCurrency: 'XCD',
  idCaptureRequirement: 'idCardOrPassport',
  idDocumentTypes: [
    DocumentType.Passport,
    DocumentType.Id,
    DocumentType.IdentityDriverLicense,
  ],
  existingCustomer: {
    maxAccountsPerType: 2,
  },
  autoApproveUnemployedProfessions: [
    Profession.Pensioner,
    Profession.Housewife,
    Profession.Unemployed,
  ],
  showRiskSectorFlagQuestion: false,
  showSelfEmployedWithRiskSectorFlagQuestion: true,
  jointAccountRelationshipOptions: [
    { value: 'PARENT', i18nKey: 'minorOthers.form.relationship.parent' },
    {
      value: 'LEGAL_GUARDIAN',
      i18nKey: 'minorOthers.form.relationship.legalGuardian',
    },
  ],
};

export const getExtraBasicInfoQuestions = (user: User) => {
  if (isMinorUser(user)) {
    return defaultGetExtraBasicInfoQuestions(user);
  }
  return {
    ...defaultGetExtraBasicInfoQuestions(user),
    [QuestionCode.AccountPurpose]: {
      enabled: isBusinessPurposeQuestionEnabled(user),
      question: 'questionDrawer.accountPurpose.question',
      priority: 0,
    },
  };
};
